/**
 * Read the signed JWT from the URL fragment.
 * Web platform embeds:  <iframe src="...#t=<jwt>">
 *
 * Fragment is used (not query string) so the token stays out of HTTP logs
 * and Referer headers.
 */

const FRAGMENT_KEY = 't';

let cached: string | null = null;

export function getJWT(): string | null {
  if (cached !== null) return cached;
  if (typeof location === 'undefined') return null;

  const raw = location.hash.startsWith('#') ? location.hash.slice(1) : location.hash;
  if (!raw) return null;

  const params = new URLSearchParams(raw);
  cached = params.get(FRAGMENT_KEY);
  return cached;
}

/** Best-effort decode of the JWT payload for display (does NOT verify). */
export function decodeJWTUnsafe(token: string): Record<string, unknown> | null {
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = b64.length % 4 === 0 ? '' : '='.repeat(4 - (b64.length % 4));
    return JSON.parse(atob(b64 + pad));
  } catch {
    return null;
  }
}
